module.exports = __webpack_public_path__ + "static/Kwera_Credits_Jacob_Photo-ce96f93682c5378a4a3c250895cc8fd4.png";